/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Speaker_IdInputs */

const en_automatic_speaker_id = /** @type {(inputs: Automatic_Speaker_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatic Speaker Identification`)
};

const fr_automatic_speaker_id = /** @type {(inputs: Automatic_Speaker_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identification automatique des intervenants`)
};

const de_automatic_speaker_id = /** @type {(inputs: Automatic_Speaker_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische Sprechererkennung`)
};

const it_automatic_speaker_id = /** @type {(inputs: Automatic_Speaker_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identificazione automatica dell'altoparlante`)
};

const ru_automatic_speaker_id = /** @type {(inputs: Automatic_Speaker_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматическая идентификация говорящего`)
};

const es_automatic_speaker_id = /** @type {(inputs: Automatic_Speaker_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identificación automática del hablante`)
};

const zh_cn2_automatic_speaker_id = /** @type {(inputs: Automatic_Speaker_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动说话人识别`)
};

const ja_automatic_speaker_id = /** @type {(inputs: Automatic_Speaker_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動話者識別`)
};

const hi_automatic_speaker_id = /** @type {(inputs: Automatic_Speaker_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वचालित स्पीकर पहचान`)
};

const pt_pt2_automatic_speaker_id = /** @type {(inputs: Automatic_Speaker_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identificação automática de locutores`)
};

/**
* | output |
* | --- |
* | "Automatic Speaker Identification" |
*
* @param {Automatic_Speaker_IdInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_speaker_id = /** @type {((inputs?: Automatic_Speaker_IdInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Speaker_IdInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_automatic_speaker_id(inputs)
	if (locale === "de") return de_automatic_speaker_id(inputs)
	if (locale === "it") return it_automatic_speaker_id(inputs)
	if (locale === "ru") return ru_automatic_speaker_id(inputs)
	if (locale === "es") return es_automatic_speaker_id(inputs)
	if (locale === "zh-CN") return zh_cn2_automatic_speaker_id(inputs)
	if (locale === "ja") return ja_automatic_speaker_id(inputs)
	if (locale === "hi") return hi_automatic_speaker_id(inputs)
	if (locale === "pt-PT") return pt_pt2_automatic_speaker_id(inputs)
	return en_automatic_speaker_id(inputs)
});